var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#11B2A8",
    fillRule: "nonzero",
    strokeWidth: 3.75,
    d: "M39.87 87.5L21.554 74.19A45.75 45.75 0 0 1 2.706 38.055l-.534-27.927c21.2 0 33.765-2.63 37.693-7.888 4.086 5.258 16.657 7.888 37.713 7.888l-.533 27.923a45.75 45.75 0 0 1-18.853 36.14L39.87 87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 6,
    d: "M25.792 44.4l9.835 7.55 17.442-21.563"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.2bee7ad4f45b49c10a48c275fadabe86.svg";
export { ForwardRef as ReactComponent };